require('./footer.scss');
require('bootstrap-sass/assets/javascripts/bootstrap.js');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { isEmpty } = require('lodash');
import OKFooter from 'ok-footer';
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @components
const ChatContainer = require('components/chat/ChatContainer');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
// @helpers
const withContactCenterValidation = require('utilities/withContactCenterValidation');
const { APIGet } = require("utilities/APIRequestHelper");
// @contants
const { CHAT } = require('constants/flagBasedFeatures');

class Footer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            footerProps: null
        }

        this.buildFooterProps = this.buildFooterProps.bind(this)
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        if (!__CONTACT_CENTER__) {
            this.buildFooterProps()
            this.props.chatAvailabilityStatus();
        }
    }

    buildFooterProps() {
        const { language, loggedIn, referenceElement, rootUrl } = this.props;
        const footerDataUrl = apiURLBuilder.getURL('footerbar');

        APIGet({
            url: footerDataUrl,
            params: {
                query: {
                    language: ['es', 'en', 'pt', 'nl', 'fr', 'de'].includes(language) ? language : 'es'
                }
            }
        }).then(data => {
            if (!!data.config) {
                // THIS SHOULD COME FROM API
                data.config.microdata = {};
                data.config.microdata.bank_or_credit_union = {
                    address: 'Paseo de la Castellana, 134 - Madrid 28046',
                    image: 'https://www.openbank.es/profiles/ok/themes/custom/openbank_bootstrap/images/logo_openbank_iso.png',
                    name: 'Openbank: Banco Online del Grupo Santander',
                    telephone: '91 177 33 37'
                };
            }

            var sources = {
                authenticated: loggedIn,
                data: data,
                lang: language,
                maxYElement: referenceElement,
                rootUrl: rootUrl,
                placeholder: '#footerbar',
                side: loggedIn ? 'privada' : 'publica' // @hardcoded
            };

            this.setState({footerProps: sources})
        });
    }

    render() {
        if (__CONTACT_CENTER__) {
            return null;
        }

        const  {
            chatStatus,
            isNerudaUser,
            originCountry,
            hideFooter
        } = this.props;
        const { footerProps } = this.state;

        let chatContainer = <ChatContainer />;
        if (isNerudaUser || (!isEmpty(chatStatus) && (!chatStatus.chatAvailability || chatStatus.nextOpening < 0))) {
            chatContainer = null;
        }
        const props = { ...footerProps, onScroll: this.handleOnScroll, disabledBackToTop: false, offsetX: 80, offsetY: 20, originCountry }

        return (
            <div className={`footer ${hideFooter ? 'hide-footer' : ''}`}>
                <FeatureTogglingRender notAllowedProductKey={CHAT} >
                    {chatContainer}
                </FeatureTogglingRender>
                {!!footerProps && <OKFooter {...props}/>}
            </div>
        );
    }
}

Footer.propTypes = {
    originCountry: PropTypes.string.isRequired,
    chatAvailabilityStatus: PropTypes.func,
    chatStatus: PropTypes.object,
    isNerudaUser: PropTypes.bool.isRequired,
    language: PropTypes.string,
    referenceElement: PropTypes.object,
    rootUrl: PropTypes.string.isRequired,
    loggedIn: PropTypes.bool
};

module.exports = Footer;
module.exports.FooterCCValidated = withContactCenterValidation(module.exports);
